const columnMenuStyling = (params) => {
  // reverted to the default positioning 10.02.2022
  if (params.type === 'columnMenu') {
    const columnMenuPopup = params.ePopup;
    const newTop = columnMenuPopup.offsetTop;
    columnMenuPopup.style.top = newTop + 'px';

    columnMenuPopup.style.boxShadow = '19px 0px 9px -3px rgba(34, 60, 80, 0.07)';
    return columnMenuPopup;
  }
};

export default columnMenuStyling;
